import React from 'react';
import './Hero.css';
import heroBg from '../../../../assets/images/hero/background.webp';
import outline from '../../../../assets/images/hero/outline.png';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="hero">
      
      <img src={heroBg} alt="bg" className="hero-bg" />

      <div className="hero-overlay"></div>

      <img src={outline} alt="outline" className="hero-outline" />

      <div className="hero-content">
        <h1>
          Excellence in Pharmaceutical <br />
          Innovation & Manufacturing
        </h1>

        <p>
          Advanced Pharmaceutical Industries (API) is a modern, forward looking
          pharmaceutical manufacturing project in Iraq dedicated to producing
          high-quality medicines and advanced biologics using internationally
          aligned technologies and quality standards.
        </p>

        <Link to="/manufacture" className="hero-btn">Read more</Link>
      </div>



    </section>
  );
};

export default Hero;